import hoverintent from 'hoverintent'

import { LOCAL_STORAGE_ORDER_CART_KEY } from './cart.js'

import { isInstitutional } from './authentication/authentication-manager.js'

function bindEvents(isLargeScreen, elements) {
  const expandedClass = 'is-expanded'
  const {
    crossSiteSelectElement,
    navElement,
    drawerToggleElements,
    itemElements,
    mainHeader,
  } = elements

  drawerToggleElements.forEach((element) => {
    element.addEventListener('click', () => {
      const mainHeaderSticky = document.querySelector('.sticky-header')
      navElement.classList.toggle(expandedClass)
      if (mainHeaderSticky) {
        mainHeader.classList.remove('sticky-header')
      }
    })
  })

  crossSiteSelectElement?.addEventListener('change', (event) => {
    window.location.href = event.target.value
  })

  itemElements.forEach((itemElement) => {
    const toggleElement = itemElement

    // Only do "on click" if it's mobile/tablet
    if (!isLargeScreen) {
      toggleElement.addEventListener('click', (e) => {
        // Prevent navigation from top-level A tag if it's not Search
        if (
          !toggleElement.querySelector('.Search-dropdown') &&
          e.srcElement.classList.contains('Navigation-action')
        ) {
          e.preventDefault()
        }

        const isOpen = itemElement.classList.contains(expandedClass)

        itemElement.classList.toggle(expandedClass)

        toggleElement.setAttribute('aria-expanded', !isOpen)
      })
    }

    // Only do "hover" if it's not mobile/tablet
    if (isLargeScreen) {
      hoverintent(
        itemElement,
        // mouseenter
        () => {
          itemElement.classList.add(expandedClass)
          toggleElement.setAttribute('aria-expanded', true)
        },
        // mouseleave
        () => {
          itemElement.classList.remove(expandedClass)
          toggleElement.setAttribute('aria-expanded', false)
        }
      )
    }
  })
}

function getActiveTab() {
  const url = window.location.href
  const urlParts = url.split('/')
  const navItems = isInstitutional()
    ? ['who-we-are', 'what-we-offer', 'insights']
    : [
        'blog',
        'cti-blog',
        'investment-products',
        'insights',
        'resources',
        'about-us',
        'about',
        'investment-capabilities',
      ]

  let selectedItem = ''

  navItems.forEach((item) => {
    if (!selectedItem) {
      // to avoid unintended matches, check for wildcards 1, 2, and 3 after the domain name.
      if (
        urlParts[3] === item ||
        urlParts[4] === item ||
        urlParts[5] === item
      ) {
        selectedItem = item
      }
    }
  })

  return selectedItem
}

function updateNavigation(navElement) {
  const navItems = navElement.querySelectorAll('.Navigation-item')

  if (navItems && navItems.length > 0) {
    const selectedItem = getActiveTab()

    navItems.forEach((item) => {
      const link = item.querySelector('.Navigation-action')
      const isActive =
        selectedItem &&
        ((link?.href && link.href.indexOf(`/${selectedItem}`) >= 0) ||
          (link?.attributes['href'] &&
            link?.attributes['href'].value.indexOf(`/${selectedItem}`) >= 0))
      const isBlog = selectedItem === 'cti-blog' || selectedItem === 'blog'
      const isInsightsTab = link?.href && link.href.indexOf('/insights') >= 0

      link?.classList.remove('active')

      if (isActive || (isBlog && isInsightsTab)) {
        link?.classList.add('active')
      }
    })
  }
}

export function updateCartCount() {
  const cartCountElements = [
    ...document.querySelectorAll('.user-navigation-cart-count'),
  ]
  const storage = localStorage.getItem(LOCAL_STORAGE_ORDER_CART_KEY)
  const items = (storage && JSON.parse(storage)) || []
  const cartCount = items.reduce((result, item) => {
    return result + (parseInt(item.quantity) || 1)
  }, 0)

  cartCountElements &&
    cartCountElements.forEach((element) => {
      element.innerText = cartCount || ''
    })
}

export default function () {
  const isLargeScreen = window.matchMedia('(min-width: 1025px)').matches
  const navElement = document.querySelector('.nav-container')
  const drawerToggleElements = [
    ...document.querySelectorAll('.Navigation-toggle'),
  ]
  const mainHeader = document.querySelector('.MainHeader')
  const crossSiteSelectElement = document.getElementById(
    'mobile-cross-site-nav'
  )
  const itemElements = [...document.querySelectorAll('.Navigation-item')]
    // only bind to items with a dropdown
    .filter((element) => !!element.querySelector('.Navigation-dropdown'))

  const hasNeededElements = navElement && drawerToggleElements && itemElements

  if (!hasNeededElements) {
    console.warn(
      'One or more navigation elements could not be found. Nav component was not initialized.'
    )
    return
  }

  updateNavigation(navElement)

  /*
   * TODO: reference this once user service is ready to be implemented:
   * https://develop.ampf.com/bitbucket/projects/BRC/repos/bloomreach-frontend/browse/assets/cti/js/_nav.js?at=6911f7588a0278a6fd22457c1bc2295484e873b3#71-102,120
   */

  updateCartCount()
  bindEvents(isLargeScreen, {
    crossSiteSelectElement,
    navElement,
    drawerToggleElements,
    itemElements,
    mainHeader,
  })
}
